import React, { useState } from 'react';
import generateQRCode from '../utils/generateQRCode';
import ShareOptions from './ShareOptions';

interface QRCodeFormProps {
  onSubmit: (submittedUrl: string) => void;
}

const QRCodeForm: React.FC<QRCodeFormProps> = ({ onSubmit }) => {
  const [inputValue, setInputValue] = useState('');
  const [qrCode, setQrCode] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(inputValue);

    try {
      const generatedQRCode = await generateQRCode(inputValue);
      setQrCode(generatedQRCode);
    } catch (error) {
      console.error('Error generating QR code:', error);
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Enter URL"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
        />
        <button type="submit">Generate QR Code</button>
      </form>
      {/* {qrCode && (
        <div>
          <img src={qrCode} alt="Generated QR Code" />
          <ShareOptions qrCodeUrl={qrCode} />
        </div>
      )} */}
    </div>
  );
};

export default QRCodeForm;